import type { FeedatyResponse, FeedatyReviewsData } from 'shared/types/Feedaty';
import useSWR from 'swr';
import useSdk from 'helpers/hooks/useSdk';
import { revalidateOptions } from 'frontastic';

const useReviews = (productKey?: string) => {
  const sdk = useSdk();
  const result = useSWR(
    ['/action/feedaty/getReviews', productKey],
    () => {
      return sdk.callAction<FeedatyResponse<FeedatyReviewsData>>({
        actionName: 'feedaty/getReviews',
        payload: { sku: productKey },
      });
    },
    revalidateOptions,
  );

  return result.data?.isError ? undefined : result.data?.data.Data;
};

export default useReviews;
